import withSharedStyles from "./theme/Shared.style";
import { color, radius, shadow, fontSize } from "./theme/tokens";

// GToast: black pill, bottom-centre, orange action text on black (6.2:1).
// App renders the ThemeProvider itself, so these styles get MUI's default
// theme: read tokens directly, never theme.tokens / theme.media here.
const withCustomStyles = withSharedStyles(() => {
  const toast = {
    backgroundColor: `${color.ink} !important`,
    color: `${color.bg} !important`,
    borderRadius: `${radius.pill}px !important`,
    boxShadow: `${shadow.overlay} !important`,
    padding: "4px 8px 4px 20px !important",
    minHeight: 48,
    fontSize: fontSize.body,
    fontWeight: 600
  };

  return {
    base: toast,
    success: toast,
    info: toast,
    warning: toast,
    error: {
      ...toast,
      "&::before": {
        content: "''",
        width: 8,
        height: 8,
        flex: "none",
        borderRadius: radius.pill,
        backgroundColor: color.dangerOnDark,
        marginRight: 10
      }
    },
    message: {
      padding: "8px 0 !important"
    },
    // "&&" doubles specificity so these win over GButton's ghost colours
    notistackText: {
      "&&": {
        color: color.brand,
        fontWeight: 700,
        "&:hover": { backgroundColor: "rgba(255,255,255,.08)" }
      }
    }
  };
});

export default withCustomStyles;
